export function testMultipleFiles() {
  log('test multiple files')

  for (let i = 0; i < 10; i++) {
    log(`${i} test multiple files`)
  }
}
